import { Component, Input } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-datatable',
  templateUrl: './datatable.component.html',
  styleUrl: './datatable.component.scss'
})
export class DatatableComponent {

  @Input() data: any;

  jsonData: any;
  columns: any;

  constructor(private dataService: DataService) {}


  async ngOnInit() {
    const jsonData = await this.getDataFromArg(this.data);

    this.jsonData = jsonData;

    this.generateColumns();
  }

  generateColumns() {
    if (this.jsonData && this.jsonData.length) {
      this.columns = Object.keys(this.jsonData[0]).map(key => ({ field: key, header: key.toUpperCase() }));
    }
  }

  async getDataFromArg(data: any) {

    let managerOu: any = localStorage.getItem('managerOus');

    managerOu = managerOu ? JSON.parse(managerOu) : null;

    if (data.tag && data.tag === 'MANAGER' && managerOu && managerOu.length > 0) {
      let res = await this.dataService.postData(
        'dashboards/dynamic-aggregation',
        {
          aggregation: data.aggregation,
          tableName: data.table,
          managerOus: managerOu
        }
      );
      return res.data;
    } else {
      let res = await this.dataService.postData(
        'dashboards/dynamic-aggregation',
        {
          aggregation: data.aggregation,
          tableName: data.table
        }
      );
      return res.data;
    }
  }

}
